import { useQuery } from '@tanstack/react-query';

import { SEARCH_GC_TIME, SEARCH_STALE_TIME } from '@/consts/search';
import searchItems from '@/requests/search/searchItems';

import type { SearchResults } from '@/types';

/**
 * Preset search for a **submitted** term (`['search', query]`), disabled while
 * the term is empty. The caller decides what "submitted" means — the debounce
 * in `useSearch` — so typing never fires a request per keystroke.
 */
const useSearchQuery = (query: string) =>
  useQuery<SearchResults>({
    queryKey: ['search', query],
    queryFn: ({ signal }) => searchItems({ query, signal }),
    enabled: query.length > 0,
    staleTime: SEARCH_STALE_TIME,
    gcTime: SEARCH_GC_TIME,
    // A failed search offers an explicit Retry, so don't spend the user's
    // time (or mobile data) on silent attempts first.
    retry: false,
  });

export default useSearchQuery;
